import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLamborghiniComponent } from './simple-icons-lamborghini.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLamborghiniComponent ],
    exports:      [ SimpleIconsLamborghiniComponent ],
    bootstrap:    []
})
export class SimpleIconsLamborghiniModule {}
